import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './components/School/SchoolCheckbox.css';
import App from './App';
import { BrowserRouter, useLocation } from "react-router-dom"
import holisticAnalytics from './utils/holisticAnalytics';
import store from "./redux/store.js"
import { Provider } from 'react-redux';
import reportWebVitals from './reportWebVitals';
import { registerServiceWorker, ensurePushSubscription, isSchoolRoute, isRunningAsPWA, getPWAInstallContext, setPWAInstallContext } from './utils/pwa-utils';
import {ThemeProvider} from "../src/components/UI/Theme/ThemeContext";
import axios from 'axios';
import { getOrCreateDeviceId } from './utils/deviceId';



// Page view tracker component
const RouteChangeTracker = () => {
  const location = useLocation();
  React.useEffect(() => {
    holisticAnalytics.trackPageView(location.pathname);
  }, [location.pathname]);
  React.useEffect(() => {
    // Keep the linked manifest + install-context in sync with in-app (SPA) navigation,
    // since an install prompt can fire well after the page's initial full load.
    setPWAInstallContext(isSchoolRoute(location.pathname) ? 'school' : 'main');
  }, [location.pathname]);
  return null;
};

const root = ReactDOM.createRoot(document.getElementById('root'));

// Select the app identity before the browser evaluates installability.
const manifestLink = document.querySelector('link[rel="manifest"]');
if (manifestLink) {
  manifestLink.href = isSchoolRoute() ? '/manifest-schools.json' : '/manifest.json';
}

// Older installs may retain the shared root start URL; route them using the
// context captured when the install was initiated.
if (isRunningAsPWA() && window.location.pathname === '/' && getPWAInstallContext() === 'school') {
  window.location.replace('/schools');
}

// Attach device id header globally
try {
  const did = getOrCreateDeviceId();
  axios.defaults.headers.common['x-device-id'] = did;
} catch (_) {}
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <RouteChangeTracker />
        <ThemeProvider>
          <App />
        </ThemeProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log());

// Register service worker for PWA functionality
registerServiceWorker();

// If permission is already granted and user is logged in, ensure we sync push subscription
try {
  if (Notification && Notification.permission === 'granted') {
    ensurePushSubscription();
  }
} catch(_) {}
